export const websiteRedirectDisabled = ({ hasWebsite }) => !hasWebsite;

export const websiteRedirectDescription = ({ hasWebsite }) =>
  hasWebsite
    ? "Redirect the public event page directly to the Website URL."
    : "Add a Website above to send fans there instead of the Opendate event page.";

export const websiteRedirectSuccessMessage = (enabled) =>
  enabled
    ? "Public event page will redirect to the website"
    : "Public event page will no longer redirect";
